(() => {
  if (customElements.get('recently-viewed-products')) {
    return;
  }

  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.productsHandle = localStorage.getItem('lastViewedProductId');
    }

    connectedCallback() {
      this.isInitialized = false;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;

          this.isInitialized = true;
          this.init();
        },
        { rootMargin: '400px 0px 0px 0px' },
      );

      this.observer.observe(this.parentElement);
    }

    init() {
      if (this.productsHandle) {
        this.classList.remove('hidden');

        const handles = this.productsHandle.split(',');
        handles.length = 10;

        const fetchPromises = handles.map((handle) => {
          return fetch(`products/${handle}?view=card`).then((response) =>
            response.ok ? response.text() : '',
          );
        });

        Promise.all(fetchPromises).then((htmlArray) => {
          const wrapper = this.querySelector('[data-swiper-wrapper]');
          const combinedHTML = htmlArray.join('');

          if (combinedHTML) {
            wrapper.insertAdjacentHTML('beforeend', combinedHTML);
          }
        });
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
})();
